export default "__VITE_ASSET__DF2Yv7eH__"